// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1QHl6","cell":"ColumnAccessor_cell__2in5K","firstCellAccent":"ColumnAccessor_firstCellAccent__2c8OQ"};